<template>
  <v-menu v-model="menu" :close-on-content-click="false" offset-y offset-x>
    <template v-slot:activator="{ on, attrs }">
      <v-btn v-bind="attrs" v-on="on" color="primary" class="mr-n3" outlined small>
        <span class="caption">
          {{ label }}
        </span>
        <v-icon small right> mdi-calendar-search-outline </v-icon>
      </v-btn>
    </template>
    <v-date-picker
      v-model="date"
      @change="mountDateFilterParams"
      color="primary"
      :locale="localeLanguage"
      type="month"
      no-title
    />
  </v-menu>
</template>

<script>
import { mapGetters, mapMutations, mapActions } from 'vuex'
import moment from 'moment-timezone'

export default {
  name: 'AdminPendingInvoicesFilters',

  computed: {
    ...mapGetters(['isLoading']),

    localeLanguage() {
      return localStorage.getItem('user_language') ?? 'pt-BR'
    }
  },

  methods: {
    ...mapActions(['fetchAdminHostPendingInvoices']),
    ...mapMutations(['setFilters']),

    mountDateFilterParams(date) {
      const startMonth = moment(date).startOf('month').add(0, 'days').format('YYYY-MM-DD') + 'T00:00:01Z'
      const endMonth = moment(date).endOf('month').format('YYYY-MM-DD') + 'T23:59:59Z'
      const formattedStartMonth = moment(startMonth).add(1, 'days').format('DD/MM')
      const formattedEndMonth = moment(endMonth).format('DD/MM')
      const to = this.$t('filters.date.to')

      this.$nextTick(() => {
        this.setFilters({
          startDate: startMonth,
          endDate: endMonth,
        })
      })

      this.$nextTick(() => {
        this.label = `${formattedStartMonth} ${to} ${formattedEndMonth}`
        this.fetchAdminHostPendingInvoices()
      })
    },

    setInitialPendingRouteStatus() {
      this.$router.push({ query: { ...this.$route.query, tab: 'PENDING' } }).catch((err) => {
        if (err.name !== 'NavigationDuplicated') return
      })
    }
  },

  data() {
    return {
      label: '',
      menu: false,
      timezone: moment.tz.guess(),
      date: new Date().toISOString(),
    }
  },

  mounted() {
    this.mountDateFilterParams(this.date)
    this.setInitialPendingRouteStatus()
  },
}
</script>

<style>
.invoices-filter__text {
  width: 140px;
  text-align: center;
}

.invoices-filter__text .v-input__prepend-inner {
  transform: scale(.85) !important;
  opacity: 0.75;
}
</style>
